// Remembers that a given affiliate-area password was entered correctly, so the
// user isn't prompted again on later visits (across page reloads and new tabs).
//
// Both the combined overview (/affiliates, password 0987) and each per-affiliate
// page (/{route}, AFFILIATE_PASSWORD 3950) use this. Keying by a namespace lets
// one password unlock every page that shares it: enter it once on any affiliate
// page and the individual pages stop asking too.
//
// We persist the password itself in localStorage (not just a flag) so that if the
// password is ever rotated, the stored value no longer matches and the user is
// re-prompted automatically. This is no weaker than the existing flow, which
// already sends the password as a plaintext query string to the API.

const KEY_PREFIX = 'aff-auth:';

// A stored password unlocks a namespace. Use 'overview' for the admin overview
// and 'affiliate' for the shared per-affiliate password.
export function isRemembered(namespace: string, correctPassword: string): boolean {
  try {
    return localStorage.getItem(KEY_PREFIX + namespace) === correctPassword;
  } catch {
    return false; // private mode / storage disabled
  }
}

export function remember(namespace: string, correctPassword: string): void {
  try {
    localStorage.setItem(KEY_PREFIX + namespace, correctPassword);
  } catch {
    /* private mode / storage disabled — just don't persist */
  }
}
